var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72036 0.00230293L15.8098 1.3865C16.0611 1.41545 16.1901 1.70361 16.0427 1.90887L9.75595 10.7771L17.7926 13.3929C18.0202 13.4666 18.0978 13.7508 17.9373 13.9311L1.92841 31.8862C1.68368 32.1612 1.24025 31.8941 1.36788 31.5494L6.81657 16.9127L0.227347 14.7167C0.0641894 14.6628 -0.0305427 14.4917 0.00892798 14.3246L3.35888 0.256245C3.39836 0.0917737 3.55361 -0.0174358 3.72071 0.00229956L3.72036 0.00230293Z",
    fill: "#32589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.5f80e921bf143b51dfd3d400c29123d1.svg";
export { ForwardRef as ReactComponent };